var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 待调试 "),_c('share',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }